export default __webpack_public_path__ + "static/media/Roboto-Bold.6cd35edf.woff2";